import { createContext, useCallback, useContext, useMemo, useState } from "react";

const EnquiryPopupContext = createContext(null);

export function EnquiryPopupProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [prefill, setPrefill] = useState(null);

  const openPopup = useCallback((data) => {
    setPrefill(data || null);
    setIsOpen(true);
  }, []);

  const closePopup = useCallback(() => setIsOpen(false), []);

  const value = useMemo(
    () => ({ isOpen, prefill, openPopup, closePopup }),
    [isOpen, prefill, openPopup, closePopup]
  );

  return <EnquiryPopupContext.Provider value={value}>{children}</EnquiryPopupContext.Provider>;
}

export function useEnquiryPopup() {
  const ctx = useContext(EnquiryPopupContext);
  if (!ctx) {
    throw new Error("useEnquiryPopup must be used within an EnquiryPopupProvider");
  }
  return ctx;
}
